var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"rootContainer"}},[_c('div',{attrs:{"id":"mainContainer"}},[_c('LanguageDropdown'),_c('router-view',{attrs:{"rewardDetails":_vm.rewardDetails,"rewardData":_vm.rewardData},on:{"rewardData":_vm.getRewardData,"Details":_vm.getRewardDetails}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }